import { AnalyticsBrowser } from "@segment/analytics-next";
import { posthog } from "posthog-js";

import { analyticsWriteKey, flowApiUrl, posthogSendKey } from "src/api/hosts";
import { createPosthogPlugin } from "src/instrumentation/posthogPlugin";

export const analytics = new AnalyticsBrowser();

export const loadAnalytics = () => {
  if (
    analyticsWriteKey() !== "" &&
    posthogSendKey() !== "" &&
    // either use has opted into tracking or not responded to the cookie banner at all
    (localStorage.getItem("user_accepts_analytics_cookies") === "true" ||
      localStorage.getItem("user_accepts_necessary_cookies") !== "true")
  ) {
    // initialize posthog first, otherwise we run the risk
    // of not capturing the session_id correctly
    posthog.init(posthogSendKey(), {
      api_host: "https://ph.tm.taktile.com",
      ui_host: "https://eu.posthog.com",
      capture_pageview: false, // pageviews get captured via analytics.tsx
      enable_heatmaps: true,
      autocapture: true,
      enable_recording_console_log: true,
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
          password: true,
          email: true,
        },
        maskCapturedNetworkRequestFn: (request) => {
          // only capture requests to Flow api
          if (request.name.startsWith(flowApiUrl())) {
            return request;
          }

          // remove request and response body for all other requests
          request.requestBody = undefined;
          request.responseBody = undefined;

          return request;
        },
      },
      loaded: (posthog_instance) => {
        analytics
          .load(
            {
              writeKey: analyticsWriteKey(),
              cdnURL: "https://stcdn.tm.taktile.com",
            },
            {
              integrations: {
                "Segment.io": {
                  apiHost: "stapi.tm.taktile.com/v1",
                },
              },
            },
          )
          .then(([analytics]) => {
            analytics.register(createPosthogPlugin(posthog_instance));
          });
      },
    });
  }
};
